export default __webpack_public_path__ + "static/media/sigal.73ca77db.png";